class Labels {
  //Labels
  static LBL_INVALID_ID = "LBL_INVALID_ID";
  static LBL_YES_CANCEL = "LBL_YES_CANCEL";
  static LBL_NO_CONTINUE = "LBL_NO_CONTINUE";
  static LBL_CANCEL_DIALOG_TITLE = "LBL_CANCEL_DIALOG_TITLE";
  static LBL_CANCEL_DIALOG_DESC = "LBL_CANCEL_DIALOG_DESC";
  static LBL_SUBMIT_PROPOSAL = "LBL_SUBMIT_PROPOSAL";
  static LBL_SUBMIT_PROPOSAL_REMARK = "LBL_SUBMIT_PROPOSAL_REMARK";
  static LBL_PROPOSAL_SUBMISSION_SUCCESSFUL_TITLE =
    "LBL_PROPOSAL_SUBMISSION_SUCCESSFUL_TITLE";
  static LBL_PROPOSAL_SUBMISSION_SUCCESSFUL_DESC =
    "LBL_PROPOSAL_SUBMISSION_SUCCESSFUL_DESC";
  static LBL_REVIEWED_SIGNED = "LBL_REVIEWED_SIGNED";
  static LBL_SMS_SENDED = "LBL_SMS_SENDED";
  static LBL_RETRY_IN = "LBL_RETRY_IN";
  static LBL_LINK_EXPIRED = "LBL_LINK_EXPIRED";
  static LBL_PROPOSAL_LINK_EXPIRED = "LBL_PROPOSAL_LINK_EXPIRED";
  static LBL_PROPOSAL_LINK_EXPIRED_DESC = "LBL_PROPOSAL_LINK_EXPIRED_DESC";

  static ERROR_CORRESPONDENCE_ADDRESS_1 = "ERROR_CORRESPONDENCE_ADDRESS_1";
  static ERROR_CORRESPONDENCE_ADDRESS_2 = "ERROR_CORRESPONDENCE_ADDRESS_2";
  static ERROR_CORRESPONDENCE_ADDRESS_3 = "ERROR_CORRESPONDENCE_ADDRESS_3";
  static ERROR_CORRESPONDENCE_ADDRESS_4 = "ERROR_CORRESPONDENCE_ADDRESS_4";

  static ERROR_MOBILE_NUMBER = "Error mobile number";
  static ERROR_EMAIL_ADDRESS_1 = "Fill in the required field";
  static ERROR_EMAIL_ADDRESS_2 = "Invalid email format";
  static ERROR_EMAIL_ADDRESS_3 = "Invalid email format";
  static ERROR_EMAIL_ADDRESS_4 = "Invalid email format";
  static ERROR_EMAIL_ADDRESS_5 = "Invalid email format";
  static ERROR_EMPTY_BANK_REFERENCE_NO = "ERROR_EMPTY_BANK_REFERENCE_NO";
  static ERROR_EMPTY_DATE_OF_QUOTATION = "ERROR_EMPTY_DATE_OF_QUOTATION";
  static ERROR_EMPTY_DATE_OF_BIRTH = "ERROR_EMPTY_DATE_OF_BIRTH";
  static ERROR_DATE_OF_BIRTH_FUTURE_DATE = "ERROR_DATE_OF_BIRTH_FUTURE_DATE";
  static ERROR_DATE_OF_BIRTH_BETWEEN_19_AND_60 =
    "ERROR_DATE_OF_BIRTH_BETWEEN_19_AND_60";
  static ERROR_EMPTY_CONTRIBUTION_TYPE = "ERROR_EMPTY_CONTRIBUTION_TYPE";

  static LBL_DOCUMENT_CATEGORY = "LBL_DOCUMENT_CATEGORY";
  static LBL_DOCUMENT_CATEGORY_PLACEHOLDER_FIELD =
    "LBL_DOCUMENT_CATEGORY_PLACEHOLDER_FIELD";

  static ERROR_OCCUPATION_CLASS = "ERROR_OCCUPATION_CLASS";
  static LBL_OCCUPATION_CLASS = "Occupation Class";
  static LBL_MALAYSIA_CORRESPONDENCE_ADDRESS_1 =
    "LBL_MALAYSIA_CORRESPONDENCE_ADDRESS_1";
  static LBL_EMPLOYER_CORRESPONDENCE_ADDRESS =
    "LBL_EMPLOYER_CORRESPONDENCE_ADDRESS";
  static LBL_EMPLOYER_CORRESPONDENCE_ADDRESS_1 =
    "LBL_EMPLOYER_CORRESPONDENCE_ADDRESS_1";
  static LBL_EMPLOYER_CORRESPONDENCE_ADDRESS_2 =
    "LBL_EMPLOYER_CORRESPONDENCE_ADDRESS_2";
  static LBL_EMPLOYER_CORRESPONDENCE_ADDRESS_3 =
    "LBL_EMPLOYER_CORRESPONDENCE_ADDRESS_3";

  static LBL_CORRESPONDENCE_ADDRESS_1 = "LBL_CORRESPONDENCE_ADDRESS_1";
  static LBL_CORRESPONDENCE_ADDRESS_2 = "LBL_CORRESPONDENCE_ADDRESS_2";
  static LBL_CORRESPONDENCE_ADDRESS_3 = "LBL_CORRESPONDENCE_ADDRESS_3";
  static LBL_OTHER_COUNTRY = "LBL_OTHER_COUNTRY";
  static LBL_YEARS_SMOKED = "LBL_YEARS_SMOKED";

  static LBL_CREATED_DATE = "LBL_CREATED_DATE";
  static LBL_LAST_UPDATED = "LBL_LAST_UPDATED";

  static LBL_PORTAL_VERSION = "LBL_PORTAL_VERSION";
  static LBL_SUPPORT_EMAIL_HELPDESK = "LBL_SUPPORT_EMAIL_HELPDESK";

  static LBL_QUOTATION_DELETE_DIALOG_TITLE =
    "LBL_QUOTATION_DELETE_DIALOG_TITLE";
  static LBL_QUOTATION_DELETE_DIALOG_DESC = "LBL_QUOTATION_DELETE_DIALOG_DESC";
  static LBL_QUOTATION_DELETE_YES = "LBL_QUOTATION_DELETE_YES";

  static LBL_PROPOSAL_DELETE_DIALOG_TITLE = "LBL_PROPOSAL_DELETE_DIALOG_TITLE";
  static LBL_PROPOSAL_DELETE_DIALOG_DESC = "LBL_PROPOSAL_DELETE_DIALOG_DESC";
  static LBL_PROPOSAL_DELETE_YES = "LBL_PROPOSAL_DELETE_YES";

  static LBL_DELETE_NO = "LBL_DELETE_NO";

  static LBL_SALES_REPRESENTATIVE_DECLARATION_TITLE =
    "LBL_SALES_REPRESENTATIVE_DECLARATION_TITLE";
  static LBL_SALES_REPRESENTATIVE_DECLARATION_DESC =
    "LBL_SALES_REPRESENTATIVE_DECLARATION_DESC";
  static LBL_REMINDER_TITLE = "LBL_REMINDER_TITLE";
  static LBL_REMINDER_DESC = "LBL_REMINDER_DESC";
  static LBL_SEND_REVIEW_REMARK = "LBL_SEND_REVIEW_REMARK";
  static LBL_SUBMIT_REQUOTATION = "LBL_SUBMIT_REQUOTATION";
  static LBL_REQUOTATION_SUCCESSFUL_TITLE = "LBL_REQUOTATION_SUCCESSFUL_TITLE";
  static LBL_STOP_WITHOUT_SAVING = "LBL_STOP_WITHOUT_SAVING";
  static LBL_QUOTATION_CREATION_SUCCESSFUL_TITLE =
    "LBL_QUOTATION_CREATION_SUCCESSFUL_TITLE";
  static LBL_QUOTATION_CREATION_SUCCESSFUL_DESC =
    "LBL_QUOTATION_CREATION_SUCCESSFUL_DESC";

  static LBL_SUPPORT_TEAM_HELPDESK = "LBL_SUPPORT_TEAM_HELPDESK";
  static LBL_TAKAFUL_MORTGAGE_PORTAL = "LBL_TAKAFUL_MORTGAGE_PORTAL";
  static LBL_HAVE_QUESTIONS = "LBL_HAVE_QUESTIONS";
  static LBL_MONDAY_TO_FRIDAY = "LBL_MONDAY_TO_FRIDAY";
  static LBL_OPERATION_HOURS = "LBL_OPERATION_HOURS";
  static LBL_QUERIES_ASSISTANCE = "LBL_QUERIES_ASSISTANCE";
  static LBL_STILL_NEED_HELP = "LBL_STILL_NEED_HELP";
  static LBL_FAQ_SEARCH_PLACEHOLDER = "LBL_FAQ_SEARCH_PLACEHOLDER";
  static LBL_FAQ = "LBL_FAQ";
  static LBL_ADD_TO_TABLE = "LBL_ADD_TO_TABLE";
  static LBL_UPDATE_TABLE = "LBL_UPDATE_TABLE";
  static LBL_DELETE = "LBL_DELETE";
  static LBL_EDIT = "LBL_EDIT";
  static LBL_ADD_DETAILS = "LBL_ADD_DETAILS";

  static LBL_NRIC = "LBL_NRIC";
  static LBL_PENDING_REVIEW = "LBL_PENDING_REVIEW";
  static LBL_TO_REVIEW_PROPOSAL = "LBL_TO_REVIEW_PROPOSAL";
  static LBL_RESEND_SMS = "LBL_RESEND_SMS";
  static LBL_VIEW_QUOTATION = "LBL_VIEW_QUOTATION";
  static LBL_VIEW_PROPOSAL = "LBL_VIEW_PROPOSAL";
  static LBL_UPDATE_PROPOSAL = "LBL_UPDATE_PROPOSAL";
  static LBL_DELETE_PROPOSAL = "LBL_DELETE_PROPOSAL";
  static LBL_DELETE_QUOTATION = "LBL_DELETE_QUOTATION";
  static LBL_CLIENTS_DETAILS = "LBL_CLIENTS_DETAILS";

  static LBL_VIEW_PROFILE = "LBL_VIEW_PROFILE";
  static LBL_CREATE_NEW_QUOTATION = "LBL_CREATE_NEW_QUOTATION";
  static LBL_CREATE_NEW_PROPOSAL = "LBL_CREATE_NEW_PROPOSAL";
  static LBL_SEARCH_PLACEHOLDER = "LBL_SEARCH_PLACEHOLDER";
  static LBL_RESULT = "LBL_RESULT";
  static LBL_RESULTS = "LBL_RESULTS";
  static LBL_SHOW = "LBL_SHOW";
  static LBL_PAGES = "LBL_PAGES";
  static LBL_PAGES = "LBL_PAGES";
  static LBL_PAGE = "LBL_PAGE";
  static LBL_SELECT_QUOTATION = "LBL_SELECT_QUOTATION";
  static LBL_SELECT_QUOTATION_DESC = "LBL_SELECT_QUOTATION_DESC";
  static LBL_GENERATED_QUOTATION = "LBL_GENERATED_QUOTATION";
  static LBL_STEP1_PROVIDE_DETAILS = "LBL_STEP1_PROVIDE_DETAILS";
  static LBL_STEP1_PROVIDE_DETAILS_DESC = "LBL_STEP1_PROVIDE_DETAILS_DESC";
  static LBL_MORTGAGE_DETAILS = "LBL_MORTGAGE_DETAILS";
  static LBL_PERSONAL_STATEMENT = "LBL_PERSONAL_STATEMENT";
  static LBL_E_CREDIT = "LBL_E_CREDIT";
  static LBL_DISCARD_DIALOG_TITLE = "LBL_DISCARD_DIALOG_TITLE";
  static LBL_DISCARD_DIALOG_DESC = "LBL_DISCARD_DIALOG_DESC";
  static LBL_STOP_WITHOUT_SAVING = "LBL_STOP_WITHOUT_SAVING";

  static LBL_REPRESENTATIVE_DETAILS = "LBL_REPRESENTATIVE_DETAILS";
  static LBL_REPRESENTATIVE_NAME = "Representative’s Name";
  /* static LBL_REPRESENTATIVE_NAME_PLACEHOLDER_FIELD="LBL_REPRESENTATIVE_NAME_PLACEHOLDER_FIELD"; */

  static LBL_STAFF_ID = "Staff Code";
  /* static LBL_STAFF_ID_PLACEHOLDER_FIELD="LBL_STAFF_ID_PLACEHOLDER_FIELD"; */

  static LBL_REPRESENTATIVE_BRANCH_CODE = "Branch Code";
  /* static LBL_REPRESENTATIVE_TAKAFUL_CODE_PLACEHOLDER_FIELD="LBL_REPRESENTATIVE_TAKAFUL_CODE_PLACEHOLDER_FIELD"; */

  static LBL_REPRESENTATIVE_PROPOSAL_DATE = "Proposal Date";

  static LBL_FINANCIAL_INSTITUTION_CODE = "LBL_FINANCIAL_INSTITUTION_CODE";
  /* static LBL_FINANCIAL_INSTITUTION_CODE_PLACEHOLDER_FIELD="LBL_FINANCIAL_INSTITUTION_CODE_PLACEHOLDER_FIELD"; */

  static LBL_REFERRAL_ID = "LBL_REFERRAL_ID";
  static LBL_REFERRAL_ID_PLACEHOLDER_FIELD =
    "LBL_REFERRAL_ID_PLACEHOLDER_FIELD";

  static LBL_FULLNAME_NRIC = "Full Name (as in IC / Other identity document)";
  /* static LBL_FULLNAME_NRIC_PLACEHOLDER_FIELD="LBL_FULLNAME_NRIC_PLACEHOLDER_FIELD"; */

  static LBL_IS_PAYOR_PERSON_COVERED = "Is the Payor same as the Person Covered?";
  static LBL_RELATIONSHIP_TO_PERSON_COVERED = "Relationship to the Person Covered";
  static LBL_SPECIFY_RELATIONSHIP = "Specify Relationship";
  static LBL_GENDER = "Gender";
  static LBL_TITLE = "Title";
  static LBL_TITLE_PLACEHOLDER_FIELD = "LBL_TITLE_PLACEHOLDER_FIELD";

  static LBL_MARTIAL_STATUS = "Marital Status";
  static LBL_MARTIAL_STATUS_PLACEHOLDER_FIELD =
    "LBL_MARTIAL_STATUS_PLACEHOLDER_FIELD";

  static LBL_RACE = "Race";
  static LBL_RACE_PLACEHOLDER_FIELD = "LBL_RACE_PLACEHOLDER_FIELD";

  static LBL_RELIGION = "Religion ";
  static LBL_RELIGION_PLACEHOLDER_FIELD = "LBL_RELIGION_PLACEHOLDER_FIELD";

  static LBL_MALAYSIAN = "Are you a Malaysian";
  static LBL_PLACE_OF_BIRTH = "Place of Birth";

  static LBL_CURRENTLY_LIVING_MALAYSIA = "Currently Living in Malaysia";
  static LBL_CORRESPONDENCE_ADDRESS = "Correspondence Address";
  static LBL_PERMANENT_ADDRESS = "Permanent Address";
  static LBL_RESIDENTIAL_ADDRESS = "Residential Address";
  static LBL_IS_PERMANENT_ADDRESS_CORRESPONDENCE_ADDRESS_SAME = "Permanent Address is same as Correspondence Address";
  static LBL_IS_RESIDENTIAL_ADDRESS_CORRESPONDENCE_ADDRESS_SAME = "Residential Address is same as Correspondence Address";

  static LBL_CORRESPONDENCE_ADDRESS_PLACEHOLDER_FIELD =
    "LBL_CORRESPONDENCE_ADDRESS_PLACEHOLDER_FIELD";

  static LBL_STATE = "LBL_STATE";
  static LBL_STATE_PLACEHOLDER_FIELD = "LBL_STATE_PLACEHOLDER_FIELD";

  static LBL_POSTCODE = "LBL_POSTCODE";
  static LBL_POSTCODE_PLACEHOLDER_FIELD = "LBL_POSTCODE_PLACEHOLDER_FIELD";

  static LBL_CITY = "LBL_CITY";
  static LBL_COUNTRY = "LBL_COUNTRY";

  static LBL_IS_MALAYSIA = "LBL_IS_MALAYSIA";

  static LBL_WEIGHT = "Weight";
  static LBL_HEIGHT = "Height";

  static LBL_IS_SMOKER = "Have you smoked cigarettes (including electronic cigarettes) or tobacco in the past 12 months?";
  static LBL_DIAGNOSED = "Have you ever been diagnosed with or had symptoms of any of the following? If your answer is Yes, you are required to provide full details.";

  static LBL_MEDICAL_HISTORY = "1. I have ever had, received medical advice or treatment for: cancer, chest pain, heart attack, stroke, diabetes mellitus, Hepatitis B or C, HIV infection, loss of hearing, loss of vision (other than vision corrected by prescription lens), any physical disability or any condition of the heart, lungs, liver, kidney, digestive system, mental or nervous system.";
  static LBL_CONSULTING = "2. In the last 2 years, I have had any other condition resulting in repeated consultations or follow-up with a doctor, specialist or hospital or continuously receiving medication for 14 days or more.";
  static LBL_FOLLOW_UP = "3. I am currently planning or been advised, to consult a doctor or undergoing investigation or awaiting the results of medical tests or follow-up.";

  static LBL_SMOKED_QUESTION = "LBL_SMOKED_QUESTION";
  static LBL_TYPE_CIGARETTES = "LBL_TYPE_CIGARETTES";
  static LBL_TYPE_CIGARETTES_PLACEHOLDER_FIELD =
    "LBL_TYPE_CIGARETTES_PLACEHOLDER_FIELD";

  static LBL_STICKS_PER_DAY = "LBL_STICKS_PER_DAY";
  static LBL_OCCUPATION = "Occupation";
  static LBL_OCCUPATION_PLACEHOLDER_FIELD = "LBL_OCCUPATION_PLACEHOLDER_FIELD";
  static LBL_NOB = "Nature of Business";
  static LBL_NOB_PLACEHOLDER_FIELD = "LBL_NOB_PLACEHOLDER_FIELD";

  static LBL_MOBILE_PHONE = "Mobile Number";
  static LBL_MOBILE_PHONE_PLACEHOLDER_FIELD =
    "LBL_MOBILE_PHONE_PLACEHOLDER_FIELD";

  static LBL_OFFICE_PHONE = "Office Phone Number";
  static LBL_OFFICE_PHONE_PLACEHOLDER_FIELD =
    "LBL_OFFICE_PHONE_PLACEHOLDER_FIELD";

  static LBL_HOME_PHONE = "Home Phone Number";
  static LBL_HOME_PHONE_PLACEHOLDER_FIELD =
    "LBL_HOME_PHONE_PLACEHOLDER_FIELD";

  static LBL_EMAIL = "E-mail";
  static LBL_EMAIL_PLACEHOLDER_FIELD = "LBL_EMAIL_PLACEHOLDER_FIELD";

  static LBL_ANNUAL_INCOME = "Annual Income";
  static LBL_EXACT_ANNUAL_INCOME = "Exact Annual Income";
  static LBL_EXACT_DUTIES = "Exact Duties";

  static LBL_EMPLOYER_COMPANY_ADDRESS = "Employer or Company Address";
  static LBL_EMPLOYER_COMPANY_NAME = "Employer or Company Name";
  static LBL_EMPLOYER_COMPANY_NAME_PLACEHOLDER_FIELD =
    "LBL_EMPLOYER_COMPANY_NAME_PLACEHOLDER_FIELD";

  static LBL_BANK_NAME = "Financing Institution";
  static LBL_FINANCING_REFERENCE_NO = "Financing Reference No.";
  static LBL_BANK_NAME_PLACEHOLDER_FIELD = "LBL_BANK_NAME_PLACEHOLDER_FIELD";
  static LBL_TYPE_FINANCING = "LBL_TYPE_FINANCING";
  static LBL_TYPE_FINANCING_PLACEHOLDER_FIELD =
    "LBL_TYPE_FINANCING_PLACEHOLDER_FIELD";
  static LBL_CATEGORY_BANK = "LBL_CATEGORY_BANK";
  static LBL_CATEGORY_BANK_PLACEHOLDER_FIELD =
    "LBL_CATEGORY_BANK_PLACEHOLDER_FIELD";

  static LBL_BANK_FINANCING_RATE = "LBL_BANK_FINANCING_RATE";
  static LBL_FINANCED = "Financed";
  static LBL_FINANCE_AMOUNT = "Financing Amount";
  static LBL_LOAN_TERM = "Loan Term";
  static LBL_COVERAGE_TERM = "Coverage Term";
  static LBL_BENEFIT = "Death and Total & Permanent Disability Benefit";
  static LBL_CRITICAL_ILLNESS_SUM_COVERED = "Critical Illness Sum Covered";
  static LBL_ACC_HOLDER = "Account Holder\'s Name";
  static LBL_ACC_NO = "Bank Account No.";
  static LBL_DIRECT_BANK_NAME = "Bank Name";
  static LBL_CREDIT_CARD_BANK_NAME = "Card Issuing Bank";
  static LBL_CREDIT_CARD_HOLDER_NAME = "Card Holder's Name";
  static LBL_CREDIT_CARD_NO = "Credit Card No.";
  static LBL_CREDIT_CARD_TYPE = "Credit Card Type";
  static LBL_CREDIT_CARD_EXPIRE_DATE = "Credit Card Expire Date";

  static LBL_ARRIVE_TIME = "When did you arrive in Malaysia?";
  static LBL_STAY_TIME = "How long do you intend to stay in Malaysia?";
  static LBL_OFFICIAL_STATUS = "What is your official status in Malaysia?";
  static LBL_OTHERS_STATUS_DETAILS = "Please Specify";
  static LBL_CURRENT_OCC_DUTIES = "Current positions in the company and exact duties?";
  static LBL_BASED_IN_COUNTRY = "Do you have the following based in Malaysia?";
  static LBL_BASED_IN_COUNTRY_DETAILS = "Provide Details";
  static LBL_SPOUSE_MALAYSIAN = "Is your spouse a Malaysian?";
  static LBL_SPOUSE_OCCUPATION = "Occupation";
  static LBL_SPOUSE_NATIONALITY = "Nationality";
  static LBL_SPOUSE_RESIDE = "Does your spouse (and any children) family reside with you?";
  static LBL_TRAVEL_OTHER_COUNTRY = "Do you intend to travel to any other country (or returning to your home) at any stage?";
  static LBL_TRAVEL_OTHER_COUNTRY_DETAILS = "Provide Details";
  static LBL_CERT_REASON = "Why do you need a Malaysian class certificate and what do you intend to do with the certificate when you leave Malaysia?";

  static LBL_TRAVEL_DURATION = "Duration of residence or travel.";
  static LBL_RESIDENTIAL_OR_TRAVEL_ADDRESS = "Residence/Travel Address";
  static LBL_TRAVEL_TIME = "How long will you travel for or how long will you stay?";
  static LBL_FIRST_VISIT = "Is this your first visit abroad for employment reasons?";
  static LBL_FIRST_VISIT_DETAILS = "Provide Details";
  static LBL_REMAIN_TRAVEL = "Will you be remaining at this location throughout your stay / travel?";
  static LBL_OTHER_LOCATION = "Where else will you be staying?";
  static LBL_LIVING_CONDITIONS = "Living conditions:-";
  static LBL_LOCATION_ACCOMMODATION = "Where is your accommodation located?";
  static LBL_LIVING_WORKING_CONDITIONS = "How would describe the living and working conditions (including the ventilation and sanitary condition)?";
  static LBL_POLITICAL_SITUATIONS = "How would you describe the political situation in your country of destination?";

  static LBL_WORKING_TIME = "How long have you been working in this occupation?";
  static LBL_JOB_INVOLVE = "Does your job involve :";
  static LBL_JOB_DETAILS = "Provide Details";
  static LBL_WORKING_WITH_HAZARD = "Are there any other hazardous duties involved?";
  static LBL_WORKING_ACCIDENT = "Have you ever had an accident whilst performing the above duties?";
  static LBL_WORKING_RIG_SITUATED = "Where is the rig situated?";
  static LBL_TRAVEL_TO_RIG_ANNUM = "How often do you travel to the oil rig per annum?";
  static LBL_TRANSPORT_MODE = "What is the mode of transport used?";
  static LBL_TRAVEL_TO_RIG_DURATION = "State duration of the journey to oil rig :";
  static LBL_TRAVEL_TO_RIG_FREQ = "Frequency of travel :";

  static LBL_ACCIDENT_IN_DUTY = "Have you ever had accident while performing your work duty?";
  static LBL_HEALTH_AFFECT = "Have your health ever affected by the occupation?";
  static LBL_CHANGE_JOB = "How long have you been working in this occupation?";
  static LBL_OCCUPATION_ENGAGE = "What is your occupation and the industry you engage in?";
  static LBL_JOB_LIFTING = "Lifting or moving heavy objects?";
  static LBL_JOB_UNDERGROUND_OR_HEIGHT = "Working underground or at height?";
  static LBL_JOB_CHEMICAL = "Working with chemical, gases, radioactive substances, with or near explosives?";
  static LBL_JOB_HIGH_VOLTAGE = "Working with high voltages?";
  static LBL_JOB_MACHINARY = "Working with any type of equipment or machine (e.g tower crane, gondola, scaffoldings, bulldozers, etc.)?";
  static LBL_JOB_ON_VESSELS = "Working on board the vessels?";
  static LBL_JOB_WITH_AIRCRAFT = "Working with regular travel in privately owned or chartered aircraft?";
  static LBL_JOB_ADVERSE_ENV = "Working in adverse environmental conditions (e.g. dust, weather, noise, etc.)?";

  static LBL_IMPORTANT_NOTICE = "LBL_IMPORTANT_NOTICE";
  static LBL_IMPORTANT_NOTICE_DESC = "LBL_IMPORTANT_NOTICE_DESC";
  static LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS =
    "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS";
  static LBL_IMPORTANT_NOTICE_DESC_PENDING_PROPOSAL_DETAILS =
    "LBL_IMPORTANT_NOTICE_DESC_PENDING_PROPOSAL_DETAILS";
  static LBL_PERSONAL_COVERED_BANK_ACCOUNT_NO =
    "LBL_PERSONAL_COVERED_BANK_ACCOUNT_NO";
  static LBL_PERSONAL_COVERED_BANK_ACCOUNT_NO_PLACEHOLDER_FIELD =
    "LBL_PERSONAL_COVERED_BANK_ACCOUNT_NO_PLACEHOLDER_FIELD";

  static LBL_STEP2_UPLOAD_DOCUMENTS = "LBL_STEP2_UPLOAD_DOCUMENTS";
  static LBL_STEP2_UPLOAD_DOCUMENTS_DESC = "LBL_STEP2_UPLOAD_DOCUMENTS_DESC";
  static LBL_SAMPLE_TITLE = "LBL_SAMPLE_TITLE";
  static LBL_SAMPLE_DESC = "LBL_SAMPLE_DESC";
  static LBL_SAMPLE_NOTE = "LBL_SAMPLE_NOTE";
  static LBL_MANDATORY_DOCUMENT = "LBL_MANDATORY_DOCUMENT";

  static LBL_STEP3_REVIEW = "LBL_STEP3_REVIEW";
  static LBL_STEP3_REVIEW_DESC = "LBL_STEP3_REVIEW_DESC";

  static LBL_STEP4_CONSENT_DECLARATION = "LBL_STEP4_CONSENT_DECLARATION";
  static LBL_STEP4_CONSENT_DECLARATION_DESC =
    "LBL_STEP4_CONSENT_DECLARATION_DESC";
  static LBL_SEND_REVIEW = "LBL_SEND_REVIEW";

  static LBL_PROPOSAL_SENT_CLIENT_REVIEW = "LBL_PROPOSAL_SENT_CLIENT_REVIEW";
  static LBL_SMS_SENT_CLIENT_REVIEW = "LBL_SMS_SENT_CLIENT_REVIEW";
  static LBL_BACK_DASHBOARD = "LBL_BACK_DASHBOARD";

  static LBL_QUOTATION_DETAILS = "LBL_QUOTATION_DETAILS";
  static LBL_PROPOSAL_DETAILS = "LBL_PROPOSAL_DETAILS";

  static LBL_LOGIN = "LBL_LOGIN";
  static LBL_USERNAME = "LBL_USERNAME";
  static LBL_USERNAME_PLACEHOLDER = "LBL_USERNAME_PLACEHOLDER";
  static LBL_PASSWORD = "LBL_PASSWORD";
  static LBL_PASSWORD_PLACEHOLDER = "LBL_PASSWORD_PLACEHOLDER";
  static LBL_FORGOT_PASSWORD = "LBL_FORGOT_PASSWORD";
  static ERROR_USERNAME = "ERROR_USERNAME";
  static ERROR_PASSWORD = "ERROR_PASSWORD";

  static LBL_DASHBOARD = "LBL_DASHBOARD";
  static LBL_PROPOSAL = "LBL_PROPOSAL";
  static LBL_QUOTATION = "LBL_QUOTATION";
  static LBL_LOGOUT = "LBL_LOGOUT";
  static LBL_LOGOUT_CONFIRMATION = "LBL_LOGOUT_CONFIRMATION";

  static LBL_AUTHENTICATION = "LBL_AUTHENTICATION";
  static LBL_AUTHENTICATION_TITLE = "LBL_AUTHENTICATION_TITLE";
  static LBL_ID_NUMBER = "IC No.";
  static LBL_ADDITIONAL_ID_TYPE = "Additional ID Type";
  static LBL_OLD_IC_NUMBER = "Old IC No.";
  static LBL_BIRTH_CERT = "Birth Certificate No.";
  static LBL_ADDITIONAL_ID_NUMBER = "Additional ID No.";
  static LBL_ID_NUMBER_PLACEHOLDER = "LBL_ID_NUMBER_PLACEHOLDER";

  static LBL_NEXT = "LBL_NEXT";
  static LBL_SUBMIT = "LBL_SUBMIT";
  static LBL_CANCEL = "LBL_CANCEL";
  static LBL_CLEAR = "LBL_CLEAR";
  static LBL_SUCCESS = "LBL_SUCCESS";

  static LBL_OTP_VERIFICATION = "LBL_OTP_VERIFICATION";
  static LBL_OTP_VERIFICATION_TITLE = "LBL_OTP_VERIFICATION_TITLE";
  static LBL_OTP_VERIFICATION_DESC = "LBL_OTP_VERIFICATION_DESC";
  static LBL_DID_NOT_RECEIVE_OTP = "LBL_DID_NOT_RECEIVE_OTP";
  static LBL_RESEND_OTP = "LBL_RESEND_OTP";

  static LBL_REVIEW_SIGN = "LBL_REVIEW_SIGN";

  static LBL_STEP_PROPOSAL = "LBL_STEP_PROPOSAL";
  static LBL_STEP_DECLARATION = "LBL_STEP_DECLARATION";
  static LBL_STEP_SIGNATURE = "LBL_STEP_SIGNATURE";

  static LBL_STEP_DECLARATION_TITLE = "LBL_STEP_DECLARATION_TITLE";
  static LBL_STEP_DECLARATION_DESC = "LBL_STEP_DECLARATION_DESC";

  static LBL_STEP_SIGNATURE_TITLE = "LBL_STEP_SIGNATURE_TITLE";

  static LBL_HELLO = "LBL_HELLO";
  static LBL_WELCOME = "LBL_WELCOME";
  static LBL_PENDING_SUBMISSION = "LBL_PENDING_SUBMISSION";
  static LBL_RECENT_ACTIVITIES = "LBL_RECENT_ACTIVITIES";
  static LBL_OVERALL_JOURNEY = "LBL_OVERALL_JOURNEY";

  static LBL_TRACK_PROPOSAL_PROGRESS = "LBL_TRACK_PROPOSAL_PROGRESS";
  static LBL_ADVERTISEMENT = "LBL_ADVERTISEMENT";

  static LBL_SUBMISSION_SUCCESS = "LBL_SUBMISSION_SUCCESS";
  static LBL_SUBMISSION_SUCCESS_DESC = "LBL_SUBMISSION_SUCCESS_DESC";

  static LBL_WEEKLY = "LBL_WEEKLY";
  static LBL_MONTHLY = "LBL_MONTHLY";
  static LBL_YEARLY = "LBL_YEARLY";
  static LBL_QUOTATION_GENERATED = "LBL_QUOTATION_GENERATED";
  static LBL_PROPOSAL_SUBMITTED = "LBL_PROPOSAL_SUBMITTED";

  static LBL_PERSONAL_DETAILS = "LBL_PERSONAL_DETAILS";
  static LBL_FINANCIAL_DETAILS = "LBL_FINANCIAL_DETAILS";
  static LBL_TAKAFUL_DETAILS = "LBL_TAKAFUL_DETAILS";
  static LBL_REVIEW_SUBMIT = "LBL_REVIEW_SUBMIT";

  static LBL_STEP = "LBL_STEP";
  static LBL_STEP1_PERSONAL_DETAILS = "LBL_STEP1_PERSONAL_DETAILS";
  static LBL_STEP1_PERSONAL_DETAILS_DESC = "LBL_STEP1_PERSONAL_DETAILS_DESC";
  static LBL_NAME = "LBL_NAME";
  static LBL_NAME_PLACEHOLDER_FIELD = "LBL_NAME_PLACEHOLDER_FIELD";
  static ERR_NAME_1 = "ERR_NAME_1";
  static ERR_NAME_2 = "ERR_NAME_2";
  static ERR_NAME_3 = "ERR_NAME_3";
  static ERR_NAME_4 = "ERR_NAME_4";
  static ERR_NAME_5 = "ERR_NAME_5";
  static ERR_NAME_6 = "ERR_NAME_6";
  static ERR_NAME_7 = "ERR_NAME_7";
  static LBL_ID_TYPE = "ID Type";
  static LBL_ID_TYPE_PLACEHOLDER_FIELD = "LBL_ID_TYPE_PLACEHOLDER_FIELD";
  static LBL_NEW_NRIC_NO = "LBL_NEW_NRIC_NO";
  static LBL_NEW_NRIC_NO_PLACEHOLDER_FIELD =
    "LBL_NEW_NRIC_NO_PLACEHOLDER_FIELD";
  static LBL_OTHER_NRIC_NO = "LBL_OTHER_NRIC_NO";
  static LBL_OTHER_NRIC_NO_PLACEHOLDER_FIELD =
    "LBL_OTHER_NRIC_NO_PLACEHOLDER_FIELD";
  static LBL_DOB = "Date of Birth";
  static LBL_DOB_PLACEHOLDER_FIELD = "LBL_DOB_PLACEHOLDER_FIELD";
  static LBL_AGE_ANB = "LBL_AGE_ANB";
  static LBL_DATE_QUOTATION = "LBL_DATE_QUOTATION";

  static LBL_DISCARD = "LBL_DISCARD";
  static LBL_SAVE_CLOSE = "LBL_SAVE_CLOSE";

  static LBL_STEP2_FINANCIAL_DETAILS = "LBL_STEP2_FINANCIAL_DETAILS";
  static LBL_STEP2_FINANCIAL_DETAILS_DESC = "LBL_STEP2_FINANCIAL_DETAILS_DESC";
  static LBL_FINANCING_BANK = "LBL_FINANCING_BANK";
  static LBL_FINANCING_BANK_PLACEHOLDER_FIELD =
    "LBL_FINANCING_BANK_PLACEHOLDER_FIELD";
  static LBL_FINANCING_ACCOUNT_NO = "LBL_FINANCING_ACCOUNT_NO";
  static LBL_FINANCING_ACCOUNT_NO_PLACEHOLDER_FIELD =
    "LBL_FINANCING_ACCOUNT_NO_PLACEHOLDER_FIELD";
  static LBL_BANK_REFERENCE_NO = "LBL_BANK_REFERENCE_NO";
  static LBL_BANK_REFERENCE_NO_PLACEHOLDER_FIELD =
    "LBL_BANK_REFERENCE_NO_PLACEHOLDER_FIELD";
  static LBL_ELIGIBLE_SCHEME = "LBL_ELIGIBLE_SCHEME";
  static LBL_FINANCING_AMOUNT = "LBL_FINANCING_AMOUNT";
  static LBL_FINANCING_PERCENTAGE = "LBL_FINANCING_PERCENTAGE";
  static LBL_COVERED_FINANCING_AMOUNT = "LBL_COVERED_FINANCING_AMOUNT";
  static LBL_ASSUMED_BANK_RATE = "LBL_ASSUMED_BANK_RATE";
  static LBL_FINANCING_PERIOD = "LBL_FINANCING_PERIOD";
  static LBL_FINANCING_PERIOD_A = "LBL_FINANCING_PERIOD_A";
  static LBL_FINANCING_PERIOD_PLACEHOLDER_FIELD =
    "LBL_FINANCING_PERIOD_PLACEHOLDER_FIELD";
  static LBL_DEFERMENT_PERIOD = "Deferment Period";
  static LBL_DEFERMENT_PERIOD_B = "LBL_DEFERMENT_PERIOD_B";
  static LBL_DEFERMENT_PERIOD_PLACEHOLDER_FIELD =
    "LBL_DEFERMENT_PERIOD_PLACEHOLDER_FIELD";

  static LBL_STEP3_TAKAFUL_DETAILS = "LBL_STEP3_TAKAFUL_DETAILS";
  static LBL_STEP3_TAKAFUL_DETAILS_DESC = "LBL_STEP3_TAKAFUL_DETAILS_DESC";
  static LBL_TERM_COVERAGE = "LBL_TERM_COVERAGE";
  static LBL_TERM_COVERAGE_A_B = "LBL_TERM_COVERAGE_A_B";
  static LBL_TERM_COVERAGE_PLACEHOLDER_FIELD =
    "LBL_TERM_COVERAGE_PLACEHOLDER_FIELD";
  static LBL_INITIAL_SUM_COVERED = "Initial Sum Covered";
  static LBL_CONTRIBUTION_AMOUNT = "Contribution Amount";
  static LBL_CONTRIBUTION_MODE = "LBL_CONTRIBUTION_MODE";
  static LBL_CASH = "LBL_CASH";
  static LBL_CONTRIBUTION_TYPE = "LBL_CONTRIBUTION_TYPE";
  static LBL_CONTRIBUTION_TYPE_PLACEHOLDER_FIELD =
    "LBL_CONTRIBUTION_TYPE_PLACEHOLDER_FIELD";

  static ERR_NRIC_1 = "ERR_NRIC_1";
  static ERR_NRIC_2 = "ERR_NRIC_2";

  static ERROR_EMPTY_VALUE = "Fill in the required field.";

  static LBL_STEP4_REVIEW_SUBMIT = "LBL_STEP4_REVIEW_SUBMIT";
  static LBL_STEP4_REVIEW_SUBMIT_DESC = "LBL_STEP4_REVIEW_SUBMIT_DESC";
  static LBL_GENERATED_DOCUMENTS = "LBL_GENERATED_DOCUMENTS";
  static LBL_CREATE_QUOTATION = "LBL_CREATE_QUOTATION";

  static LBL_PROCEED_PROPOSAL = "LBL_PROCEED_PROPOSAL";
  static LBL_PROVIDE_DETAILS = "LBL_PROVIDE_DETAILS";
  static LBL_UPLOAD_DOCUMENTS = "LBL_UPLOAD_DOCUMENTS";
  static LBL_REVIEW = "LBL_REVIEW";
  static LBL_CONSENT_DECLARATION = "LBL_CONSENT_DECLARATION";

  static LBL_REF_NO = "LBL_REF_NO";
  static LBL_ID_NO = "LBL_ID_NO";
  static LBL_CLIENT_NAME = "LBL_CLIENT_NAME";
  static LBL_PROPOSAL_NO = "LBL_PROPOSAL_NO";
  static LBL_STATUS = "LBL_STATUS";
  static LBL_CREATION_DATE = "LBL_CREATION_DATE";

  static LBL_ALL = "LBL_ALL";
  static LBL_GENERATED = "LBL_GENERATED";
  static LBL_PENDING = "LBL_PENDING";
  static LBL_DRAFT = "LBL_DRAFT";
  static LBL_UNDEFINED = "LBL_UNDEFINED";
  static LBL_SUBMITTED = "LBL_SUBMITTED";

  static LBL_CITY_PLACEHOLDER_FIELD = "LBL_CITY_PLACEHOLDER_FIELD";
  static LBL_GENDER_PLACEHOLDER_FIELD = "LBL_GENDER_PLACEHOLDER_FIELD";

  static ERROR_INCORRECT_FORMAT_DATE_OF_BIRTH =
    "ERROR_INCORRECT_FORMAT_DATE_OF_BIRTH";

  static LBL_ACCOUNT_DETAILS = "LBL_ACCOUNT_DETAILS";
  static LBL_FORGOT_PASSWORD_DESC = "LBL_FORGOT_PASSWORD_DESC";
  static LBL_USER_ID = "LBL_USER_ID";
  static LBL_USER_ID_PLACEHOLDER = "LBL_USER_ID_PLACEHOLDER";
  static LBL_FORGOT_PASSWORD_BUTTON = "LBL_FORGOT_PASSWORD_BUTTON";
  static LBL_RESET_YOUR_PASSWORD = "LBL_RESET_YOUR_PASSWORD";
  static LBL_NEW_PASSWORD = "LBL_NEW_PASSWORD";
  static LBL_NEW_PASSWORD_PLACEHOLDER = "LBL_NEW_PASSWORD_PLACEHOLDER";
  static LBL_CONFIRM_NEW_PASSWROD = "LBL_CONFIRM_NEW_PASSWROD";
  static LBL_CONFIRM_NEW_PASSWROD_PLACEHOLDER = "LBL_CONFIRM_NEW_PASSWROD_PLACEHOLDER";
  static LBL_RESET_PASSWORD = "LBL_RESET_PASSWORD";
  static LBL_MINIMUM_8_CHARACTERS = "LBL_MINIMUM_8_CHARACTERS";
  static LBL_PASSWORD_SUCCESS_UPDATED = "LBL_PASSWORD_SUCCESS_UPDATED";
  static LBL_DATE_PROPOSAL = "LBL_DATE_PROPOSAL";
  static LBL_ERROR_TITLE = "LBL_ERROR_TITLE";
  static LBL_ERROR_EXPIRY_AGE = "LBL_ERROR_EXPIRY_AGE";
  static LBL_OK = "LBL_OK";
  static LBL_SOMETHING_WENT_WRONG = "LBL_SOMETHING_WENT_WRONG";
  static LBL_AGREEMENT_ECREDIT = "LBL_AGREEMENT_ECREDIT";
  static LBL_ERROR_LOGIN_CODE_00004 = "LBL_ERROR_LOGIN_CODE_00004";
  static LBL_ERROR_LOGIN_CODE_00008 = "LBL_ERROR_LOGIN_CODE_00008";
  static LBL_ERROR_LOGIN_CODE_00009 = "LBL_ERROR_LOGIN_CODE_00009";
  static LBL_ERROR_LOGIN_CODE_00010 = "LBL_ERROR_LOGIN_CODE_00010";
  static LBL_ERROR_BANK_NO_FIXED = "LBL_ERROR_BANK_NO_FIXED";
  static LBL_ERROR_BANK_NO_RANGE = "LBL_ERROR_BANK_NO_RANGE";
  static LBL_CHARACTERS = "LBL_CHARACTERS";
  static LBL_AND = "LBL_AND";
  static LBL_INFO = "LBL_INFO";
  static LBL_INFO_MORTGAGE_DETAIL = "LBL_INFO_MORTGAGE_DETAIL";
  static LBL_ERROR_COMPANY_NAME = "LBL_ERROR_COMPANY_NAME"
  static LBL_ERROR_EMPLOYER_ADDRESS = "LBL_ERROR_EMPLOYER_ADDRESS"
  static LBL_ERROR_CITY = "LBL_ERROR_CITY";
  static LBL_ERROR_POSTAL_CODE = "LBL_ERROR_POSTAL_CODE";
  static LBL_TEMPORARY_PASSWORD = "LBL_TEMPORARY_PASSWORD";
  static LBL_AT_LEAST_1_DIGIT_NUMBER = "LBL_AT_LEAST_1_DIGIT_NUMBER";
  static LBL_1_UPPERCASE_1_LOWERCASE = "LBL_1_UPPERCASE_1_LOWERCASE";
  static LBL_SYMBOLS_SPECIAL_CHARACTER_ALLOWED = "LBL_SYMBOLS_SPECIAL_CHARACTER_ALLOWED";
  static LBL_PASSWORD_CANNOT_SAME_WITH_LAST_PASSWORD = "LBL_PASSWORD_CANNOT_SAME_WITH_LAST_PASSWORD";
  static LBL_ERROR_PROVIDE_TITLE = "LBL_ERROR_PROVIDE_TITLE";
  static LBL_ERROR_PROVIDE_RACE = "LBL_ERROR_PROVIDE_RACE";
  static LBL_ERROR_PROVIDE_RELIGION = "LBL_ERROR_PROVIDE_RELIGION";
  static LBL_ERROR_PROVIDE_CURRENTLY_LIVING = "LBL_ERROR_PROVIDE_CURRENTLY_LIVING";
  static LBL_ERROR_PROVIDE_CORRESPONDENCE_ADDRESS = "LBL_ERROR_PROVIDE_CORRESPONDENCE_ADDRESS";
  static LBL_ERROR_PROVIDE_MOBILE_NUMBER = "LBL_ERROR_PROVIDE_MOBILE_NUMBER";
  static LBL_ERROR_PROVIDE_WEIGHT = "LBL_ERROR_PROVIDE_WEIGHT";
  static LBL_ERROR_PROVIDE_HEIGHT = "LBL_ERROR_PROVIDE_HEIGHT";
  static LBL_ERROR_PROIVDE_SMOKING_STATUS = "LBL_ERROR_PROIVDE_SMOKING_STATUS";
  static LBL_ERROR_PROVIDE_TYPE_OF_SMOKING = "LBL_ERROR_PROVIDE_TYPE_OF_SMOKING";
  static LBL_ERROR_PROVIDE_YEARS_SMOKED = "LBL_ERROR_PROVIDE_YEARS_SMOKED";
  static LBL_ERROR_PROVIDE_STICKS_PER_DAY = "LBL_ERROR_PROVIDE_STICKS_PER_DAY";
  static ERROR_EMPLOYER_ADDRESS_1 = "ERROR_EMPLOYER_ADDRESS_1";
  static ERROR_EMPLOYER_ADDRESS_2 = "ERROR_EMPLOYER_ADDRESS_2";
  static ERROR_EMPLOYER_ADDRESS_3 = "ERROR_EMPLOYER_ADDRESS_3";
  static ERROR_EMPLOYER_ADDRESS_4 = "ERROR_EMPLOYER_ADDRESS_4";
  static ERROR_PROVIDE_STATE = "ERROR_PROVIDE_STATE";
  static ERROR_PROVIDE_COUNRTY = "ERROR_PROVIDE_COUNRTY";
  static LBL_ERROR_BANK_NO_OR = "LBL_ERROR_BANK_NO_OR";
  static LBL_OR = "LBL_OR";
  static LBL_INCORRECT_ID_OR_PASSWORD = "LBL_INCORRECT_ID_OR_PASSWORD";
  static LBL_ERROR_PROVIDE_OCCUPATION = "LBL_ERROR_PROVIDE_OCCUPATION";
  static LBL_ERROR_PROVIDE_NOB = "LBL_ERROR_PROVIDE_NOB";
  static LBL_ERROR_PROVIDE_OCCUPATION_CLASS = "LBL_ERROR_PROVIDE_OCCUPATION_CLASS";
  static LBL_ERROR_PROVIDE_MARITAL_STATUS = "LBL_ERROR_PROVIDE_MARITAL_STATUS";
  static LBL_ERROR_PROVIDE_ISMALAYSIAN = "LBL_ERROR_PROVIDE_ISMALAYSIAN";
  static LBL_ERROR_PROVIDE_CATEGORY_OF_BANK = "LBL_ERROR_PROVIDE_CATEGORY_OF_BANK";
  static LBL_ERROR_PROVIDE_BANK_NAME = "LBL_ERROR_PROVIDE_BANK_NAME";
  static LBL_ERROR_PROVIDE_ACCOUNT_BANK_NUMBER = "LBL_ERROR_PROVIDE_ACCOUNT_BANK_NUMBER";
  static LBL_ERROR = "LBL_ERROR";
  static LBL_SOMETHING_WENT = "LBL_SOMETHING_WENT";
  static LBL_WRONG = "LBL_WRONG";
  static LBL_COUNTRYCODE = "LBL_COUNTRYCODE";
  static ERROR_ASSURED_BANK_RATE = "ERROR_ASSURED_BANK_RATE";
  static LBL_YEARS = "LBL_YEARS";
  static LBL_SINGLE_CONTRIBUTION = "LBL_SINGLE_CONTRIBUTION";
  static LBL_YEARS_OLD = "LBL_YEARS_OLD";
  static LBL_ERRO_EMPTY_ASSUMED_BANK_RATE = "LBL_ERRO_EMPTY_ASSUMED_BANK_RATE";
  static LBL_START_DATE = "LBL_START_DATE";
  static LBL_END_DATE = "LBL_END_DATE";
  static LBL_SHOW_WITHIN = "LBL_SHOW_WITHIN";
  static LBL_ALL_TIME = "LBL_ALL_TIME";
  static LBL_LAST_30_DAYS = "LBL_LAST_30_DAYS";
  static LBL_LAST_60_DAYS = "LBL_LAST_60_DAYS";
  static LBL_LAST_90_DAYS = "LBL_LAST_90_DAYS";
  static LBL_CUSTOM = "LBL_CUSTOM";
  static LBL_RECENT_OLDEST = "LBL_RECENT_OLDEST";
  static LBL_OLDEST_RECENT = "LBL_OLDEST_RECENT";
  static LBL_ERROR_ADDRESS_SYMBOL = "LBL_ERROR_ADDRESS_SYMBOL";
  static LBL_ERROR_PERSONAL_STATEMENT_SYMBOL = "LBL_ERROR_PERSONAL_STATEMENT_SYMBOL";
  static LBL_PREVIEW_SUBMIT = "LBL_PREVIEW_SUBMIT";
  static LBL_REVIEW_ALL_DOCUMENTS = "LBL_REVIEW_ALL_DOCUMENTS";
  static LBL_ERROR_FINANCING_PERCENTAGE = "LBL_ERROR_FINANCING_PERCENTAGE";
  static LBL_ERR_ECREDIT_CHECKBOX = "LBL_ERR_ECREDIT_CHECKBOX";
  static LBL_ERR_CONSENT_DECLARATION_CHECKBOX = "LBL_ERR_CONSENT_DECLARATION_CHECKBOX";
  static LBL_IMPORTANT_NOTICE_PENDING_SUBMISSION_PROPOSAL_DETAILS = "LBL_IMPORTANT_NOTICE_PENDING_SUBMISSION_PROPOSAL_DETAILS";
  static LBL_IMPORTANT_NOTICE_DESC_PENDING_SUBMISSION_PROPOSAL_DETAILS = "LBL_IMPORTANT_NOTICE_DESC_PENDING_SUBMISSION_PROPOSAL_DETAILS";
  static LBL_IMPORTANT_NOTICE_SUBMITTED_PROPOSAL_DETAILS = "LBL_IMPORTANT_NOTICE_SUBMITTED_PROPOSAL_DETAILS";
  static LBL_ERR_MOBILE_NUMBER_MALAYSIA = "LBL_ERR_MOBILE_NUMBER_MALAYSIA";
  static LBL_ERR_OFFICE_NUMBER_MALAYSIA = "LBL_ERR_OFFICE_NUMBER_MALAYSIA";
  static LBL_ATTENTION = "LBL_ATTENTION";
  static LBL_ATTENTION_DESC = "LBL_ATTENTION_DESC";
  static LBL_ERR_FINANCIAL_ACCOUNT_NO = "LBL_ERR_FINANCIAL_ACCOUNT_NO";
  static LBL_YOUR_PROPOSAL_NUMBER = "LBL_YOUR_PROPOSAL_NUMBER";
  static LBL_ERR_THIRD_PARTY_CONSENT_CHECKBOX = "LBL_ERR_THIRD_PARTY_CONSENT_CHECKBOX";
  static LBL_OCCUPATION_CLASS_PLACEHOLDER_FIELD = "LBL_OCCUPATION_CLASS_PLACEHOLDER_FIELD";
  static LBL_COUNTRY_CODE_MOBILE_NUMBER_PLACEHOLDER_FIELD = "LBL_COUNTRY_CODE_MOBILE_NUMBER_PLACEHOLDER_FIELD";
  static LBL_COUNTRY_CODE_OFFICE_NUMBER_PLACEHOLDER_FIELD = "LBL_COUNTRY_CODE_OFFICE_NUMBER_PLACEHOLDER_FIELD";
  static LBL_MOBILE_COUNTRY_CODE = "LBL_MOBILE_COUNTRY_CODE";
  static LBL_OFFICE_COUNTRY_CODE = "LBL_OFFICE_COUNTRY_CODE";
  static LBL_CURRENT_LIVING_COUNTRY = "LBL_CURRENT_LIVING_COUNTRY";
  static LBL_CURRENT_LIVING_COUNTRY_PLACEHOLDER = "LBL_CURRENT_LIVING_COUNTRY_PLACEHOLDER";
  static LBL_COUNTRY_PLACEHOLDER = "LBL_COUNTRY_PLACEHOLDER";
  static LBL_NOTE = "LBL_NOTE";
  static LBL_UPLOAD_SUCCESS = "LBL_UPLOAD_SUCCESS";
  static LBL_UPLOAD_FAILED = "LBL_UPLOAD_FAILED";
  static LBL_UPLOAD_DELETED = "LBL_UPLOAD_DELETED";
  static LBL_UPLOAD = "LBL_UPLOAD";
  static LBL_COUNTRY_CORRESPONDENCE_ADDRESS = "LBL_COUNTRY_CORRESPONDENCE_ADDRESS";
  static LBL_COUNTRY_NON_MALAYSIAN = "LBL_COUNTRY_NON_MALAYSIAN";
  static LBL_ERROR_PROVIDE_OFFICE_NUMBER = "LBL_ERROR_PROVIDE_OFFICE_NUMBER";
  static LBL_ERROR_PROVIDE_COUNTRY_CODE_MOBILE = "LBL_ERROR_PROVIDE_COUNTRY_CODE_MOBILE";
  static ERROR_OFFICE_PHONE_NUMBER = "ERROR_OFFICE_PHONE_NUMBER";
  static LBL_CLASS = "LBL_CLASS";
  static LBL_OCCUPATION_CLASS_INFO_1 = "LBL_OCCUPATION_CLASS_INFO_1";
  static LBL_OCCUPATION_CLASS_INFO_2 = "LBL_OCCUPATION_CLASS_INFO_2";
  static LBL_OCCUPATION_CLASS_INFO_3 = "LBL_OCCUPATION_CLASS_INFO_3";
  static LBL_OCCUPATION_CLASS_INFO_4 = "LBL_OCCUPATION_CLASS_INFO_4";
  static ERR_OTHER_ID_NO = "ERR_OTHER_ID_NO";
  static ERR_SESSION_EXPIRED_TITLE = "ERR_SESSION_EXPIRED_TITLE";
  static ERR_SESSION_EXPIRED_DESC = "ERR_SESSION_EXPIRED_DESC";
  static LBL_ERROR_EMPLOYER_OR_COMPANY_NAME_SYMBOL = "LBL_ERROR_EMPLOYER_OR_COMPANY_NAME_SYMBOL";
  static LBL_ERROR_INVALID_HEIGHT = "LBL_ERROR_INVALID_HEIGHT";
  static LBL_ERROR_INVALID_WEIGHT = "LBL_ERROR_INVALID_WEIGHT";
  static LBL_SENT_TEMPORARY_PASSWORD = "LBL_SENT_TEMPORARY_PASSWORD";
  static ERR_VERIFY_OTP = "ERR_VERIFY_OTP";
  static ERR_INVALID_CREDENTIALS = "ERR_INVALID_CREDENTIALS";
  static LBL_PRIVACY_NOTICE = "LBL_PRIVACY_NOTICE";
  static LBL_PRIVACY_NOTICE_DESC = "LBL_PRIVACY_NOTICE_DESC";
  static LBL_AGREEMENT_PRIVACY_POLICY = "LBL_AGREEMENT_PRIVACY_POLICY";
  static LBL_AGREEMENT_PRIVACY_POLICY_LINK = "LBL_AGREEMENT_PRIVACY_POLICY_LINK";
  static LBL_ERR_PRIVACY_POLICY = "LBL_ERR_PRIVACY_POLICY";
  static LBL_ERR_FAILED_CREATE_PROPOSAL = "LBL_ERR_FAILED_CREATE_PROPOSAL";
  static LBL_ERR_NO_DOCUMENT_QUOTATION = "LBL_ERR_NO_DOCUMENT_QUOTATION";
  static LBL_ERR_QUOTATION_NOT_ALLOWED_EDIT = "LBL_ERR_QUOTATION_NOT_ALLOWED_EDIT";
  static LBL_ERR_PROPOSAL_NOT_ALLOWED_EDIT = "LBL_ERR_PROPOSAL_NOT_ALLOWED_EDIT";
  static LBL_EXIT = "LBL_EXIT";
  static LBL_OTHER_IDTYPE = "Identification No.";
  static LBL_OTHER_ID_TYPE_PLACEHOLDER_FIELD = "LBL_OTHER_ID_TYPE_PLACEHOLDER_FIELD";
  static ERROR_EMPTY_ANB = "ERROR_EMPTY_ANB";
  static ERROR_EMPTY_OTHER_ID_NO = "ERROR_EMPTY_OTHER_ID_NO"
}

export default Labels;
